import {
    AbstractedTariffWithHardwareOffer,
    PriceType,
} from '@vfde-sails/glados-v2';
import {
    BASKET_PROPOSITION_HARDWAREONLY,
    BASKET_PROPOSITION_MULTICARDCONTRACT,
    BASKET_PROPOSITION_ULTRACARD,
    BasketProposition,
    createBasket,
    createBasketItem,
    createBasketProposition,
    generateDeeplink,
} from '@vfde-sails/utils';
import { IInitialState } from 'Container/App/interface';

const generateDeeplinkHelper = (
    { atomicId, salesChannel, isHardwareOnly, paymentMethod }: IInitialState['customerConfig'],
    subscription: AbstractedTariffWithHardwareOffer | null = null,
) => {
    const propositions: BasketProposition[] = [];

    const basketItem = createBasketItem({
        sublevelTariffId: paymentMethod === PriceType.Monthly && !isHardwareOnly
            ? subscription?.subLevelId
            : undefined,
        ...atomicId && { atomicDeviceId: atomicId },
    });

    const propositionType =
        paymentMethod === PriceType.Monthly && !isHardwareOnly
            ? BASKET_PROPOSITION_MULTICARDCONTRACT
            : BASKET_PROPOSITION_HARDWAREONLY
    ;

    propositions.push(createBasketProposition(propositionType, [basketItem]));

    if (paymentMethod === PriceType.Onetime && !isHardwareOnly) {
        const oneNumberBasketItem = createBasketItem({
            simCardId: '7496',
        });
        propositions.push(createBasketProposition(BASKET_PROPOSITION_ULTRACARD, [oneNumberBasketItem]));
    }

    const basket = createBasket(salesChannel, propositions);

    return generateDeeplink(basket, true);
};

export default generateDeeplinkHelper;
